import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

const DURATION = 100;
const OFFSET = -50;

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateAndScroll = (sectionId, event) => {
    if (event) event.preventDefault(); // δεν αφήνουμε το <a> να κάνει full reload

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo(sectionId, {
          duration: DURATION,
          delay: 0,
          smooth: true,
          offset: OFFSET,
        });
      }, 100); // από 500 → 100
    } else {
      scroller.scrollTo(sectionId, {
        duration: DURATION,
        delay: 0,
        smooth: true,
        offset: OFFSET,
      });
    }
  };

  const handleGoToBiography = (event) => {
    event.preventDefault();
    navigate('/biography');
  };

  return (
    <footer>
      <div className="social-icons">
        <a
          href="https://www.linkedin.com/in/sofia-davi-255784248/"
          target="_blank"
          rel="noreferrer"
          aria-label="Προφίλ στο LinkedIn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            className="social-icon linkedin-icon"
          >
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.228c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 11.228h-3v-5.5c0-1.518-3-1.399-3 0v5.5h-3v-10h3v1.22c1.396-2.586 6-2.777 6 2.476v6.304z" />
          </svg>
        </a>
      </div>

      <p>
        Design and Development by{' '}
        <a href="https://github.com/vtmag" className="hover-animate">
          Magda Vitsioti
        </a>
      </p>
      <p>&copy; 2025 Δαβή Σοφία - Όλα τα δικαιώματα κατοχυρωμένα</p>

      <nav>
        <ul>
          <li><a href="/cookies-policy">Πολιτική Cookies</a></li>
          <li><a href="/privacy-policy">Πολιτική Απορρήτου</a></li>
        </ul>
      </nav>

      <nav className="footer-menu">
        <ul>
          <li>
            <a
              href="/"
              onClick={(e) => handleNavigateAndScroll('arxikh', e)}
            >
              Αρχική
            </a>
          </li>
          <li>
            <a
              href="/"
              onClick={(e) => handleNavigateAndScroll('services', e)}
            >
              Υπηρεσίες
            </a>
          </li>
          <li>
            <a
              href="/biography"
              onClick={handleGoToBiography}
            >
              Βιογραφικό
            </a>
          </li>
          <li>
            <a
              href="/"
              onClick={(e) => handleNavigateAndScroll('faq', e)}
            >
              FAQ
            </a>
          </li>
          <li>
            <a
              href="/"
              onClick={(e) => handleNavigateAndScroll('contact', e)}
            >
              Επικοινωνία
            </a>
          </li>
          <li>
            <a href="/booking">Ραντεβού</a>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
